export default "__VITE_ASSET__Raa2jUH6__"